export default "__VITE_ASSET__xR6PVfu7__"